var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconActionBarSend(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18.3 18.3",
    style: {
      enableBackground: "new 0 0 18.3 18.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#1C4566;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Send_x2F_icon_x5F_send",
    transform: "translate(-9.000000, -9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(9.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "st0",
    d: "M15.5,3.9L11,15.7L8.4,11L15.5,3.9z M14.4,2.8L7.3,9.9L2.6,7.3L14.4,2.8z M18.1,0.2 c-0.2-0.2-0.5-0.3-0.8-0.2L0.5,6.4C0.2,6.5,0,6.8,0,7.1c0,0.3,0.2,0.6,0.4,0.7l6.4,3.6l3.6,6.5c0.1,0.2,0.4,0.4,0.7,0.4 c0,0,0.1,0,0.1,0c0.3,0,0.5-0.2,0.6-0.5L18.2,1C18.4,0.8,18.3,0.4,18.1,0.2L18.1,0.2z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconActionBarSend);
export default __webpack_public_path__ + "static/media/icon-action-bar-send.6aaed50d484886bb07c9f3a1021ec78b.svg";
export { ForwardRef as ReactComponent };